import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45419a7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-full flex flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid m-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-5 th" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "flex w-100 font-bold" }, "自動付与タグ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-7 td customer-tags" })
], -1))
const _hoisted_3 = { class: "col-5 th" }
const _hoisted_4 = { class: "mt-2 block" }
const _hoisted_5 = { class: "col-7 td customer-tags" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block mt-2" }, "データなし", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "grid m-0 flex-none" }
const _hoisted_11 = { class: "col-5 th" }
const _hoisted_12 = { class: "flex w-100 align-items-center justify-content-between font-bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手動タグ", -1))
const _hoisted_14 = { class: "flex align-items-center" }
const _hoisted_15 = { class: "pi pi-question-circle btn-orange mr-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7 td customer-tags" }, null, -1))
const _hoisted_17 = { class: "col-5 th" }
const _hoisted_18 = { class: "flex w-100 align-items-center justify-content-between mt-2 gap-0" }
const _hoisted_19 = {
  key: 0,
  class: "pi pi-exclamation-circle text-orange-500 ml-2 cursor-pointer"
}
const _hoisted_20 = { class: "col-7 td customer-tags" }
const _hoisted_21 = {
  key: 0,
  class: "grid m-0 flex-none"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5 th" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mt-2 block" }, "RIPICLEタグ")
], -1))
const _hoisted_23 = { class: "col-7 td customer-tags" }
const _hoisted_24 = { class: "grid m-0 flex-grow-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5 th" }, null, -1))
const _hoisted_26 = { class: "col-7 td flex align-items-end justify-content-center my-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex justify-content-center w-100 mb-2" }, "過去タグ履歴", -1))
const _hoisted_28 = {
  key: 0,
  class: "customer-tags"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-between mb-3 px-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "メニュータグ"),
  /*#__PURE__*/_createElementVNode("span", null, "予約回数")
], -1))
const _hoisted_30 = { class: "overflow-scroll max-h-25rem px-3" }
const _hoisted_31 = {
  key: 1,
  class: "text-center"
}
const _hoisted_32 = { class: "tag-dialog" }

import { onBeforeMount, ref, inject, computed } from "vue";
import { get, set, templateRef } from "@vueuse/core";

// PrimeVueコンポーネントのインポート
import Button from "primevue/button";
import Tag from "primevue/tag";

// ローカルコンポーネントのインポート
import TagDialog from "./dialog.vue";

// 型定義のインポート
import { ITag } from "@/clinic/typings";
import { TagTypeEnum, TagTypeOrderEnum } from "@/clinic/typings/enums/tag";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

// Vuexストアのインポート
import { useStore } from "vuex";

/**
 * 顧客タグのプロパティ型定義
 */
type ICustomerTag = {
  /** 顧客ID */
  customerId: number;
  /** 自動付与タグの配列 */
  automatic_tags: any[];
  /** 手動タグの配列 */
  tags: ITag[];
};

/** Vuexストアのインスタンス */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    customerId: null,
    automatic_tags: null,
    tags: null
  },
  emits: ["refreshCustomer"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** 顧客ID */
  customerId: number;
  /** 自動付与タグの配列 */
  automatic_tags: any[];
  /** 手動タグの配列 */
  tags: ITag[];
};

/**
 * 顧客タグ管理コンポーネント
 * 自動付与タグ、手動タグ、パートナータグの表示と管理を行う
 */

// Vue関連のインポート
const store = useStore();

/**
 * コンポーネントのプロパティ
 * 顧客タグ情報を含む
 */


/**
 * 顧客情報更新イベントを発行
 * @emits refreshCustomer - 顧客情報の再取得を要求するイベント
 */


/** クリニックID */
const clinicId = ref(0);

/** タグダイアログのテンプレート参照 */
const tagDialog = templateRef<InstanceType<typeof TagDialog> | null>("tagDialog", null);

/** 予約サービス履歴のタグ名 */
const servicesHistoryName = "booking_services_history";

/**
 * 予約サービス履歴のタグ情報を取得
 * @returns {any} 予約サービス履歴のタグ情報
 */
const bookingServicesHistory = computed(() => props.automatic_tags?.find(tag => tag.name_en === servicesHistoryName));

/**
 * 自動付与タグから予約サービス履歴を除いたタグ一覧
 * @returns {any[]} 自動付与タグの配列
 */
const automaticTags = computed(() => props.automatic_tags?.filter(tag => tag.name_en !== servicesHistoryName));

/** 過去サービス履歴ダイアログの表示状態 */
const showPrevServices = ref(false);

/**
 * 手動タグをカテゴリ別にグループ化
 * @returns {Record<string, ITag[]>} カテゴリ別にグループ化された手動タグ
 */
const manualTagsByCategory = computed((): Record<string, ITag[]> => {
  const tags = props.tags || [];
  const manualTags = tags
    .filter(tag => tag.type != TagTypeEnum.partner)
    .sort((first, second) => {
      const firstOrder = TagTypeOrderEnum[first.type as keyof typeof TagTypeOrderEnum];
      const secondOrder = TagTypeOrderEnum[second.type as keyof typeof TagTypeOrderEnum];
      return firstOrder - secondOrder;
    });

  const results = manualTags.reduce((result: Record<string, ITag[]>, item) => {
    /**
     * カテゴリ名がある場合はカテゴリ別にグループ化
     * カテゴリがない場合は「カテゴリ未選択」に分類
     */
    if (item.category_name) {
      (result[item.category_name] = result[item.category_name] || []).push(item);
    } else {
      (result["カテゴリー未選択"] = result["カテゴリー未選択"] || []).push(item);
    }
    return result;
  }, {});

  // カテゴリをソートして「カテゴリ未選択」を最後に表示
  const sortedResults: Record<string, ITag[]> = {};

  // カテゴリ名とposition_numberのマッピングを作成
  const categoryWithPosition: Array<{ name: string; position: number }> = [];

  Object.keys(results).forEach(categoryName => {
    if (categoryName === "カテゴリー未選択") {
      // 「カテゴリ未選択」は最後に表示（position: 9999）
      categoryWithPosition.push({ name: categoryName, position: 9999 });
    } else {
      // 設定済みカテゴリは最初のタグのposition_numberを使用
      const firstTag = results[categoryName][0];
      const position = firstTag?.position_number || 0;
      categoryWithPosition.push({ name: categoryName, position });
    }
  });

  // position_numberで昇順ソート
  categoryWithPosition.sort((a, b) => a.position - b.position);

  // ソートされた順序で結果を構築
  categoryWithPosition.forEach(({ name }) => {
    sortedResults[name] = results[name];
  });

  return sortedResults;
});

/**
 * パートナータグ（RIPICLE等）の一覧
 * @returns {ITag[]} パートナータグの配列
 */
const partnerTags = computed(() => {
  return props.tags?.filter(tag => tag.type === TagTypeEnum.partner);
});

/**
 * クリニックIDを設定
 */
const setClinicId = async () => set(clinicId, await inject("clinicId"));

/**
 * タグ編集ダイアログを表示
 */
const onShowingDialog = () => {
  const dialog = get(tagDialog);
  if (dialog) {
    dialog.setCustomerId(props.customerId);
    dialog.showDialog();
  }
};

/**
 * 顧客情報の更新を親コンポーネントに通知
 */
const onRefreshCustomer = () => emits("refreshCustomer");

onBeforeMount(async () => await setClinicId());

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(automaticTags), (tag) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "grid m-0 flex-none",
          key: tag
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(tag.name_ja), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (tag.value && Array.isArray(tag.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tag.value, (tagInfo) => {
                    return (_openBlock(), _createBlock(_unref(Tag), {
                      class: "mr-1 additional-tag font-normal mb-2",
                      key: tagInfo,
                      value: tagInfo
                    }, null, 8, ["value"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (tag.value && !Array.isArray(tag.value))
              ? (_openBlock(), _createBlock(_unref(Tag), {
                  key: 1,
                  class: "mr-1 additional-tag font-normal mb-2 mt-2",
                  value: tag.value
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (!tag.value || tag.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("i", _hoisted_15, null, 512), [
                [
                  _directive_tooltip,
                  'タグの編集は設定からできます',
                  void 0,
                  { right: true }
                ]
              ]),
              _createVNode(_unref(Button), {
                icon: "pi pi-pencil",
                class: "p-0 h-auto p-button-text btn-orange shadow-none",
                onClick: onShowingDialog
              })
            ])
          ])
        ]),
        _hoisted_16
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(manualTagsByCategory)), (categoryName, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "grid m-0 flex-none",
          key: index
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(categoryName) + " ", 1),
                (categoryName === 'カテゴリー未選択')
                  ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_19, null, 512)), [
                      [
                        _directive_tooltip,
                        '設定 > セグメント用手動タグ登録 からカテゴリーを設定してください',
                        void 0,
                        { right: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(manualTagsByCategory)[categoryName] || [], (tag) => {
                return (_openBlock(), _createBlock(_unref(Tag), {
                  class: _normalizeClass([tag.type == _unref(TagTypeEnum).partner ? 'special-tag' : 'manual-tag', 'mr-1 font-normal mb-2']),
                  key: tag.id,
                  value: tag.name
                }, null, 8, ["class", "value"]))
              }), 128))
            ])
          ])
        ]))
      }), 128)),
      (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Ripicle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partnerTags), (tag) => {
                return (_openBlock(), _createBlock(_unref(Tag), {
                  class: "mr-1 font-normal mb-2 special-tag",
                  key: tag.id,
                  value: tag.name
                }, null, 8, ["value"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_unref(Button), {
            label: _unref(bookingServicesHistory)?.name_ja,
            class: "p-button-light",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showPrevServices.value = true))
          }, null, 8, ["label"])
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: showPrevServices.value,
        modal: "",
        class: "w-5 border-0",
        draggable: false
      }, {
        header: _withCtx(() => [
          _hoisted_27,
          _createElementVNode("i", {
            class: "pi pi-times right-0 cursor-pointer mr-3 absolute",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPrevServices.value = false))
          })
        ]),
        default: _withCtx(() => [
          (Object.keys(_unref(bookingServicesHistory)?.value).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(bookingServicesHistory)?.value), (tag, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex justify-content-between py-3 border-bottom-1 border-200",
                      key: index
                    }, [
                      _createVNode(_unref(Tag), {
                        class: "bg-cancel font-normal",
                        value: tag
                      }, null, 8, ["value"]),
                      _createVNode(_unref(Tag), {
                        class: "bg-cancel font-normal mr-0",
                        value: `${_unref(bookingServicesHistory)?.value[tag]}回`
                      }, null, 8, ["value"])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, "データなし"))
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(TagDialog, {
        ref_key: "tagDialog",
        ref: tagDialog,
        onRefreshCustomer: onRefreshCustomer
      }, null, 512)
    ])
  ], 64))
}
}

})